import HCRender from "aldoo-ra/HelpCenter/hc-render"

const BreadcrumbsSection = ({ items = [] }) => {
  const Breadcrumbs = HCRender.getFragment("Breadcrumbs")

  return (
    <div className="w-full max-w-w2_xl flex-shrink-0 my-6 md:my-9 lg:my-12 xl:my-14 mx-auto">
      <div className="w-fit flex items-center paper_20 px-4 py-2 rounded-[24px]">
        {Breadcrumbs && <Breadcrumbs items={items} />}
      </div>
    </div>
  )
}

export default BreadcrumbsSection
